var ko = require('knockout');
var $ = require('jquery');
var Dialog = require("./dialog");

function ContentLibraryItemViewModel(data) {
    var self = this;

    self.id = ko.observable(data.id);
    self.name = ko.observable(data.name);
    self.formNumber = ko.observable(data.formNumber);
    self.description = ko.observable(data.description);
    self.videoTitle = ko.observable(data.videoTitle);
    self.videoTranscript = ko.observable(data.videoTranscript);
    self.url = ko.observable(data.url);
    self.target = ko.observable(data.target);
    self.rel = ko.observable(data.rel);
    self.quantity = ko.observable(parseInt(data.quantity));
    self.orderable = ko.observable(data.orderable);
    self.linkType = ko.observable(data.linkType);
    self.parentName = ko.observable(data.parentName);
    self.isVideo = ko.observable(data.isVideo);

    self.itemId = ko.computed(function () {
        return "item-" + self.id();
    }, this);

    self.linkClass = ko.computed(function () {
        return self.isVideo() ? 'ws-video' : '';
    }, this);

    self.linkText = ko.computed(function () {
        return (self.parentName() ? self.parentName() + " " : "") + self.name();
    }, this);

    self.linkTextWithoutParent = ko.computed(function () {
        return self.name();
    }, this);

    self.linkTextWithoutParentAddQuantityOrder = ko.computed(function () {
        return self.linkTextWithoutParent() + " order quantity";
    }, this);

    self.iconClass = ko.computed(function () {
        switch (self.linkType()) {
            case 'pdf':
                return 'fa-light fa-file-pdf';
            case 'youtube':
                return 'fa-brands fa-youtube ws-color-youtube-red';
            case 'external':
                return 'fa-light fa-arrow-up-right-from-square';
            case 'doc':
                return 'fa-light fa-file-word';
            case 'xls':
                return 'fa-light fa-file-excel';
            default:
                return 'fa-light fa-code';
        }
    }, this);

    self.loadVideo = function (item, event) {
        event.stopImmediatePropagation();

        var $target = $(event.currentTarget),
            urlSplit = item.url().split("?"),
            leftPartUrl = urlSplit[0],
            rightPartUrl,
            playerSrc;

        if (urlSplit[1] !== 'undefined') {
            rightPartUrl = "&" + urlSplit[1];
            playerSrc = leftPartUrl + "?enablejsapi=1&origin=" + window.location.origin + "&rel=0" + rightPartUrl;
        }
        else {
            playerSrc = leftPartUrl + "?enablejsapi=1&origin=" + window.location.origin + "&rel=0";
        }

        var $dialog = $($target.data('ws-dialog-content'));
        Dialog.openDialog($dialog, event, {
            url: playerSrc,
            title: item.videoTitle(),
            transcript: item.videoTranscript()
        });
    };
}

module.exports = ContentLibraryItemViewModel;